// extracted by mini-css-extract-plugin
export default {"modalContent":"RejectOrderModal_modalContent__nv-uq","plainText":"RejectOrderModal_plainText__KHfFf","boldBlackText":"RejectOrderModal_boldBlackText__NE7wJ"};